export const PrivateEmployeesRealTimeMessage = Object.freeze({
    ReceiveEmployeeNames: 'ReceiveEmployeesForPrivateOffering',
    ReceiveEmployeesForPrivateOfferingError: 'ReceiveEmployeesForPrivateOfferingError',
    ReceiveEmployeesForPrivateOfferingWithValidationError: 'ReceiveEmployeesForPrivateOfferingWithValidationError',
    ReceiveValidations: 'ReceiveEmployeesForPrivateOfferingWithValidation',
    RequestEmployeeNames: 'GetAvailableEmployeesForPrivateOffering',
    RequestEmployeeValidations: 'GetAvailableEmployeesForPrivateOfferingWithValidation',
    RequestCancelTask: 'RequestCancelTask',
});
